import useSWR from "swr";
import { useFetcher } from "./useFetcher";
import type { Enrollment } from "./getEnrollments";

export default function useClientEnrollments() {
  const fetcher = useFetcher();
  const { data, isLoading, error } = useSWR<Enrollment[] | null>(
    "/api/enrollment",
    fetcher,
  );
  return {
    enrollments: data || [],
    isLoadingEnrollments: isLoading,
    enrollmentsError: error,
  };
}
